import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.state = { hasError: true, error, errorInfo };
  }

  handleGoHome = () => {
    window.location.href = '/';
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
          <Card className="max-w-2xl w-full p-8">
            <div className="flex items-center space-x-3 mb-6">
              <AlertTriangle className="text-red-500" size={48} />
              <div>
                <h1 className="text-2xl font-bold text-slate-900">
                  Es ist ein Fehler aufgetreten
                </h1>
                <p className="text-slate-600 mt-1">
                  Die Anwendung hat einen unerwarteten Fehler festgestellt.
                </p>
              </div>
            </div>

            {this.state.error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                <h3 className="font-semibold text-red-900 mb-2">Fehlermeldung:</h3>
                <pre className="text-sm text-red-800 whitespace-pre-wrap break-words">
                  {this.state.error.toString()}
                </pre>
                
                {this.state.errorInfo && (
                  <>
                    <h3 className="font-semibold text-red-900 mt-4 mb-2">Stack Trace:</h3>
                    <pre className="text-xs text-red-700 whitespace-pre-wrap break-words max-h-48 overflow-auto">
                      {this.state.errorInfo.componentStack}
                    </pre>
                  </>
                )}
              </div>
            )}

            <div className="flex space-x-3">
              <Button
                onClick={this.handleGoHome}
                className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700"
              >
                <Home size={18} />
                <span>Zurück zur Übersicht</span>
              </Button>
              <Button
                onClick={this.handleReload}
                variant="outline"
                className="flex items-center space-x-2"
              >
                <RefreshCw size={18} />
                <span>Neu laden</span>
              </Button>
            </div>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
